// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import store from './store'
import Toasted from 'vue-toasted';
import Loading from 'vue-loading-overlay';
import TreeView from 'vue-json-tree-view';
import axios from 'axios';

import VueGraph from 'vue-graph'

// todo
// cssVars()

Vue.use(VueGraph)

Vue.use(BootstrapVue)

Vue.use(Toasted, {
    className: 'vueToasted'
});

Vue.use(TreeView);

Vue.use(Loading, {
    container: null,
    canCancel: false,
    onCancel: self.onCancel,
    color: "#5164a9",
    loader: 'spinner',
    width: 64,
    height: 64,
    backgroundColor: '#ffffff',
    opacity: 0.5,
});

// Add a request interceptor
axios.interceptors.request.use(function(config) {
    // // Do something before request is sent
    // const baseURL = 'URL_API';
    // // const baseURL = 'https://portalapicloudid.dev.vaultid.com.br';
    // // const baseURL = 'http://localhost:82';
    // // Set base URL (IF not set http or https protocol)
    // if (config.url.includes('http') === false) {
    //     const newUrlPath = baseURL + config.url;
    //     config.url = newUrlPath;
    // }

    // modify headers
    const token = localStorage.access_token;
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, function(error) {
    // Do something with request error
    return Promise.reject(error);
});

// Add a response interceptor
axios.interceptors.response.use(function(response) {
    if (response.status === 401 || response.status === 403) {
        localStorage.removeItem('access_token');
        window.location.href = '/#/pages/login';
    }
    return response;
}, function(error) {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
        localStorage.removeItem('access_token');
        window.location.href = '/#/pages/login';
    }
    return Promise.reject(error);
});

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: {
        App
    }
});